import type React from 'react'
import {Search} from 'pepsico-ds'

type ISearchProps = React.ComponentProps<typeof Search>

const AutoCompleteWrapper: React.FC<ISearchProps> = props => {
  return <Search {...props} />
}

export default AutoCompleteWrapper
